import { formatCurrency } from '../formatCurrency/formatCurrency';

export const formatPricePerTonne = (value: number | string, currency: string, maximumFractionDigits = 0): string => {
  if (typeof value === 'string') {
    return formatPricePerTonne(Number.parseFloat(value), currency);
  }
  return (
    formatCurrency(value, {
      currencyCode: currency,
      maximumFractionDigits,
    }) + ' / MT'
  );
};
